import React from "react";
import { FaHeartBroken } from "@react-icons/all-files/fa/FaHeartBroken";
import { FaHeart } from "@react-icons/all-files/fa/FaHeart";
import { RiMeteorFill } from "@react-icons/all-files/ri/RiMeteorFill";

import { useDispatch } from "react-redux";
import ReactTooltip from "react-tooltip";
import { updateUsers } from "../../3- actions/users";

function LikesSystem({ currentUser, LocalUser, setInterfaces, setPopUp }) {
  const dispatch = useDispatch();
  const localuser = JSON.parse(localStorage.getItem("profile"));
  const userLikes = currentUser?.users?.likes;

  const handleClickUpdate = () => {
    if (localuser) {
      // push to Novel_id to my old array
      if (userLikes.includes(LocalUser?._id)) {
        const likesDataObject = {
          userId: currentUser?.users?._id,
          obj: {
            likes: userLikes.filter((like) => like !== LocalUser?._id),
          },
        };
        dispatch(updateUsers(likesDataObject));
      } else {
        const likesDataObject = {
          userId: currentUser?.users?._id,
          obj: {
            likes: [...userLikes, LocalUser?._id],
          },
        };
        dispatch(updateUsers(likesDataObject));
      }
    } else {
      setInterfaces(
        0,
        setTimeout(() => {
          setPopUp(true);
        }, 10)
      );
    }
  };

  function numbersLogic(num) {
    if (num >= 1000000000) {
      return (num / 1000000000).toFixed(1).replace(/\.0$/, "") + "G";
    }
    if (num >= 1000000) {
      return (num / 1000000).toFixed(1).replace(/\.0$/, "") + "M";
    }
    if (num >= 1000) {
      return (num / 1000).toFixed(1).replace(/\.0$/, "") + "K";
    }
    if (num >= 10 && num <= 99) {
      return "0" + num;
    }
    if (num <= 9) {
      return "00" + num;
    }
    return num;
  }
  return (
    <div>
      <div className="absolute top-[-10%] md:top-0 right-0">
        <div className="flex justify-center items-center flex-col md:flex-row-reverse">
          <div data-tip data-for="Favorites">
            <div
              title="Favorites"
              onClick={handleClickUpdate}
              className="bg-primary relative duration-500 ease-in-out cursor-pointer w-12 h-12 flex justify-center items-center"
            >
              <div
                className={
                  userLikes?.includes(LocalUser?._id)
                    ? "absolute scale-1 duration-500 ease-in-out top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2"
                    : "absolute scale-0 duration-500 ease-in-out top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2"
                }
              >
                <FaHeart className="scale-[1] md:scale-[1.2] duration-500 ease-in-out" />
              </div>
              <div
                className={
                  userLikes?.includes(LocalUser?._id)
                    ? "absolute scale-0 duration-500 ease-in-out top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2"
                    : "absolute scale-1 duration-500 ease-in-out top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2"
                }
              >
                <FaHeartBroken className="scale-[1] md:scale-[1.2] duration-500 ease-in-out " />
              </div>
            </div>
            <ReactTooltip
              id="Favorites"
              className="custom-color-no-arrow"
              delayHide={100}
              textColor="#6947EF"
              backgroundColor="#D9D9D9"
              effect="solid"
            >
              <span>Favorites</span>
            </ReactTooltip>
          </div>
          <div className="bg-primary/80 text-[14px] md:text-[16px] w-12 md:w-fit h-12 flex justify-center items-center">
            <span className="px-4">{numbersLogic(userLikes?.length)}</span>
          </div>
        </div>
      </div>
      <div className="absolute top-[-10%] md:top-0 left-0">
        <div className="flex justify-center items-center flex-col md:flex-row">
          <div data-tip data-for="badge">
            <div
              title="Badge"
              className="bg-primary relative duration-500 ease-in-out cursor-pointer w-12 h-12 flex justify-center items-center"
            >
              <div className="absolute scale-1 duration-500 ease-in-out top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2">
                <RiMeteorFill className="scale-[1] md:scale-[1.2] duration-500 ease-in-out" />
              </div>
            </div>

            <ReactTooltip
              id="badge"
              className="custom-color-no-arrow"
              delayHide={100}
              textColor="#6947EF"
              backgroundColor="#D9D9D9"
              effect="solid"
            >
              <span>Badge</span>
            </ReactTooltip>
          </div>
          <div className="bg-primary/80 text-[14px] md:text-[16px] w-12 md:w-fit h-12 flex justify-center items-center">
            <span className="px-4">
              {currentUser?.users?.badgeSvg !== "" ? (
                <div className="relative">
                  <div
                    className="zoombadge blur-2xl"
                    dangerouslySetInnerHTML={{
                      __html: currentUser?.users?.badgeSvg,
                    }}
                  />
                  <div
                    className="zoombadge absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2"
                    dangerouslySetInnerHTML={{
                      __html: currentUser?.users?.badgeSvg,
                    }}
                  />
                </div>
              ) : (
                <div className="text-center scale-[0.8]">No Badge</div>
              )}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}

export default LikesSystem;
